import { gql } from '@apollo/client';
import React from 'react';
import ClockIcon from '@moda/icons/clock-16';
import { A_ROUGH_AVERAGE_OF_HOW_MANY_DAYS_THERE_ARE_IN_A_MONTH } from '@moda/portal-stanchions';
import { useCountdown } from '../../hooks/useCountdown';
import { TrunkshowHeaderCountdownFragment } from '../../generated/types';

import './TrunkshowHeaderCountdown.scss';

interface Props {
  trunkshowHeaderCountdown: TrunkshowHeaderCountdownFragment;
}

export const TRUNKSHOW_HEADER_COUNTDOWN_FRAGMENT = gql`
  fragment TrunkshowHeaderCountdownFragment on Trunkshow {
    activeStartI: active_start_i
    activeEndI: active_end_i
  }
`;

export const TrunkshowHeaderCountdown: React.FC<Props> = ({ trunkshowHeaderCountdown }) => {
  const [timeLeft, getMessageToDisplay] = useCountdown(
    trunkshowHeaderCountdown.activeStartI || 0,
    trunkshowHeaderCountdown.activeEndI || 0
  );

  if (parseInt(timeLeft.daysLeft, 10) > A_ROUGH_AVERAGE_OF_HOW_MANY_DAYS_THERE_ARE_IN_A_MONTH)
    return null;

  return (
    <div
      className={`TrunkshowHeaderCountdown ${
        parseInt(timeLeft.daysLeft, 10) < 2
          ? 'TrunkshowHeaderCountdown--urgent'
          : 'TrunkshowHeaderCountdown--normal'
      }`}
    >
      <ClockIcon className="TrunkshowHeaderCountdown__clock" />
      {getMessageToDisplay()}
    </div>
  );
};
